import {strings as reactStrings} from "library-react/res"
import {clone, Objects} from "library-js/utils";
import appStrings from "./strings"

export {default as images} from "./image"
export let strings = Objects.deepMerge(appStrings, clone(reactStrings));
export {default as styles} from "./styles"
